<div class="container">
    <mat-icon [svgIcon]="icon" class="option-icon" data-cy="new-vessel-modal-option-icon" />
    <div class="title" data-cy="new-vessel-modal-option-header">
        {{ title | translate }}
    </div>
    <div class="description" data-cy="new-vessel-modal-option-body">
        {{ description | translate }}
    </div>
    <div class="button" data-cy="new-vessel-modal-option-button-custom" (click)="optionSelected()">
        {{ button | translate }}
    </div>
</div>
